<template>
  <div class="acomodar">
    <div class="container-fluid py-3 px-4">

      <button v-if="postulanteCondic" @click="regresare" class="btn btn-danger mt-2 mx-1 mb-2">
        <i class="bi bi-skip-backward"></i>
      </button>

      <button v-else @click="listado" class="btn btn-success mt-2 mx-1 mb-2">
        <i class="bi bi-skip-backward"></i>
      </button>


      <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
        <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
          <i class="bi bi-database-fill-lock display-4 text-primary"></i>
          <div>
            <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
              BASE DE DATOS
            </p>
            <p class="mb-0 tituloResaltado fs-4 fw-bold">
              POSTULANTES
            </p>
          </div>
        </div>
      </div>

      <div v-if="mostrarInput" class="row mt-2 mx-2">
        <div class="col-3 px-5 text-center "></div>
        <div class="col-5">
          <div class="input-group">
            <!-- Icono de búsqueda -->
            <span class="input-group-text bg-white">
              <i class="bi bi-search"></i>
            </span>
            <!-- Input -->
            <input class="form-control form-control-lg tamaño" v-model="dni_busqueda" type="text" maxlength="12"
              placeholder="Buscar..." />
          </div>
        </div>

        <p v-if="alertita" class="text-danger mt-2">Alerta: no existe el usuario</p>
      </div>


      <div v-if="postulanteCondicion" class="mx-4">
        <div class="position-relative py-2 px-5">
          <div v-if="alerta" class="alert alert-danger mt-3" role="alert">
            se elimino el usuario correspondiente!
          </div>
        </div>

        <div class="col-12">
          <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100">
            <div class="table-responsive">
              <div v-if="Loader" class="w-full overflow-hidden mx-2 mt-2">
                <b-row class="">
                  <b-col cols="12" class="">
                    <b-skeleton-img no-aspect height="380px"></b-skeleton-img>
                  </b-col>
                </b-row>
              </div>

              <!-- tablas -->
              <div v-if="Tabla1" class="mt-5">
                <h5 class="text-center fw-bold">
                  CANTIDAD DE REGISTROS: <strong>{{ Info.length }}</strong>
                </h5>
                <table class="table table-bordered">
                  <thead class="reducirTamaño">
                    <tr class="bg-solimano text-white text-center text-nowrap">
                      <th>ID</th>
                      <th>CV</th>
                      <th>ESTADO DEL TRABAJADOR</th>
                      <th>ULTIMO RQ</th>
                      <th>RECORD TRABAJADOR</th>
                      <th>PERFIL PROFESIONAL</th>
                      <th>TIP. DOC</th>
                      <th>N° DOCUMENTO</th>
                      <th>APELLIDO PATERNO</th>
                      <th>APELLIDO MATERNO</th>
                      <th>NOMBRES</th>
                      <th>UBIGEO</th>
                      <th>NACIONALIDAD</th>
                      <th>ACCION</th>
                      <th>INFO.</th>
                      <th>ESTADO</th>

                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="loading">
                      <td :colspan="14" class="text-center py-4">
                        <div class="d-flex flex-column justify-content-center align-items-center">
                          <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
                          </div>
                          <p class="mt-2 text-primary fw-bold">Cargando...</p>
                        </div>
                      </td>
                    </tr>
                    <tr v-else v-for="items in paginatedInfo" :key="items.idPostulante"
                      class="text-center align-middle reducirTamaño text-nowrap">
                      <td style="text-center">{{ items.idPostulante }}</td>

                      <td v-if="items.posAdjunto != 1" class="text-center">
                        <a :href="url +
                          items.posAdjunto.slice(45, items.posAdjunto.length)
                          " target="_blank" class="btn btn-ligth container  boton-estiloCuadrado">
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                            class="bi bi-download" viewBox="0 0 16 16">
                            <path
                              d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                            <path
                              d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                          </svg>
                        </a>
                      </td>
                      <td class="text-center" v-if="items.posAdjunto == 1">
                        ...
                      </td>

                      <td :class="{
                        'text-primary': items.estadoActivo == 'CONTRATADO', 'text-danger': items.estadoActivo != 'CONTRATADO', 'text-warning': items.estadoActivo == 'EN PROCESO'
                      }" class="fw-bold "> {{ items.estadoActivo }}</td>
                      
                       <td> <button @click="abrirSolicitud(items.requerimiento)" class="btn btn-link-estilo reducirTamaño">{{ items.requerimiento }}</button> </td>


                      <td :class="{
                        'text-danger': JSON.parse(items.recordTrabajador).diasAcumulados >= 1260
                      }">
                        {{
                          JSON.parse(items.recordTrabajador).diasAcumulados == 0
                            ? '0 días'
                            : JSON.parse(items.recordTrabajador).diasAcumulados == 1
                              ? '1 día'
                              : `${JSON.parse(items.recordTrabajador).diasAcumulados} días`
                        }}
                      </td>
                      <td class="text-center">
                        <!-- Icono único con color condicional -->
                        <i class="bi-person-circle" :class="{
                          'text-success': items.posPerProfesional === 'Experto',
                          'text-warning': items.posPerProfesional === 'Intermedio',
                          'text-danger': items.posPerProfesional === 'Principiante'
                        }"></i>
                        {{ items.posPerProfesional }}
                      </td>

                      <td class="text-center">
                        <!-- Icono para el tipo de documento con color -->
                        <i :class="{
                          'bi-file-earmark-text text-primary': items.desTipDocumento === 'DNI',
                          'bi-file-earmark-check text-success': items.desTipDocumento === 'Pasaporte',
                          'bi-file-earmark-lock text-danger': items.desTipDocumento === 'Carnet de extranjería'
                        }"></i>
                        {{ items.desTipDocumento }}
                      </td>
                      <td class="text-center">
                        <!-- Icono para el número de documento -->
                        <i class="bi-file-earmark-person text-info"></i> {{ items.posNroDocumento }}
                      </td>
                      <td class="text-center">
                        <!-- Icono para el apellido paterno -->
                        <i class="bi-person text-muted"></i> {{ items.posApePaterno }}
                      </td>
                      <td class="text-center">
                        <!-- Icono para el apellido materno -->
                        <i class="bi-person text-muted"></i> {{ items.posApeMaterno }}
                      </td>
                      <td class="text-center">
                        <!-- Icono para el nombre -->
                        <i class="bi-person-fill text-primary"></i> {{ items.posNombre }}
                      </td>
                      <td class="text-center">
                        <!-- Icono para la ubicación -->
                        <i class="bi-geo-alt text-info"></i> {{ items.desDepartamento }} - {{ items.desProvincia }} - {{
                        items.desDistrito }}
                      </td>
                      <td class="text-center">
                        <!-- Icono para nacionalidad -->
                        <i class="bi-flag text-secondary"></i> {{ items.desNacionalidad }}
                      </td>
                      <td>
                        <div class="d-flex">
                          <div :title="JSON.parse(items.recordTrabajador).mensaje" class="mx-2">
                            <button :disabled="JSON.parse(items.recordTrabajador).diasAcumulados >= 1260"
                              class="btn btn-warning container  boton-estiloCuadrado"
                              @click="editar(items.idPostulante)">
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                class="bi bi-pencil-fill" viewBox="0 0 16 16">
                                <path
                                  d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                              </svg>
                            </button>
                          </div>

                          <div :title="JSON.parse(items.recordTrabajador).mensaje"
                            v-if="!items.posEstadoConvoca && items.posEstado !== '004'" class="mx-2">

                            <button
                              :disabled="JSON.parse(items.recordTrabajador).diasAcumulados >= 1260 || bontoncitoDisabled"
                              class="btn btn shadow-lg bg-success rounded text-white container  boton-estiloCuadrado"
                              @click="posteos(items.idPostulante)">
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                class="bi bi-file-earmark-plus" viewBox="0 0 16 16">
                                <path
                                  d="M8 6.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 .5-.5z" />
                                <path
                                  d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z" />
                              </svg>
                            </button>
                          </div>

                          <div :title="JSON.parse(items.recordTrabajador).mensaje"
                            v-if="items.posEstadoConvoca || items.posEstado == '004'" class="mx-2">
                            <!-- @click="editar(items.idPostulante)" -->

                            <button :disabled="JSON.parse(items.recordTrabajador).diasAcumulados >= 1260"
                              class="btn btn shadow-lg bg-danger rounded text-white container  boton-estiloCuadrado">
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                class="bi bi-lock-fill" viewBox="0 0 16 16">
                                <path
                                  d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z" />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </td>

                      <td class="text-center">

                        <button class="btn btn-ligth container" @click="mandar(items.idPostulante)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                            class="bi bi-eye" viewBox="0 0 16 16">
                            <path
                              d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                            <path
                              d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                          </svg>
                        </button>
                      </td>

                      <td v-if="(items.posEstado == '002') && items.posMotBloqueo != '000'"
                        class="text-danger text-center align-middle">
                        <div class="d-flex flex-column justify-content-center align-items-center">
                          <i class="bi bi-exclamation-octagon fs-5"></i>
                          <p class="mb-0 small">BLACK LIST</p>
                        </div>
                      </td>

                      <td v-if="(items.posEstado == '004') && items.posMotBloqueo != '000'"
                        class="text-warning text-center align-middle">
                        <div class="d-flex flex-column justify-content-center align-items-center">
                          <i class="bi bi-shield-lock fs-5"></i>
                          <p class="mb-0 small">LISTA DE RESTRICCIÓN</p>
                        </div>
                      </td>

                      <td v-if="items.posEstado == '001' && items.posMotBloqueo == '000'"
                        class="text-success text-center align-middle">
                        <div class="d-flex flex-column justify-content-center align-items-center">
                          <i class="bi bi-bag-plus fs-5"></i>
                          <p class="mb-0 small">ACTIVO</p>
                        </div>
                      </td>

                      <td v-if="items.posEstado == '002' && items.posMotBloqueo == '000'"
                        class="text-danger text-center align-middle">
                        <div class="d-flex flex-column justify-content-center align-items-center">
                          <i class="bi bi-bag-dash fs-5"></i>
                          <p class="mb-0 small">INACTIVO</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <nav aria-label="Page navigation" class="text-center">
                    <ul class="pagination text-center"></ul>
                  </nav>
                </table>
              </div>
              <!-- tabla2 -->
            </div>


            <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">

              <!-- Primera página -->
              <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
                <i class="bi bi-chevron-double-left"></i>
              </button>

              <!-- Retroceder -->
              <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
                <i class="bi bi-chevron-left"></i>
              </button>

              <!-- Página actual -->
              <span class="pagination-info fw-bold">
                Página {{ currentPage }} de {{ totalPages }}
              </span>

              <!-- Avanzar -->
              <button class="btn btn-outline-primary btn-sm" @click="currentPage++"
                :disabled="currentPage === totalPages">
                <i class="bi bi-chevron-right"></i>
              </button>

              <!-- Última página -->
              <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
                :disabled="currentPage === totalPages">
                <i class="bi bi-chevron-double-right"></i>
              </button>

            </div>



          </div>
        </div>
      </div>
      <div v-if="!postulanteCondic" class="edit-panel mt-4">
        <EditarPostulantes class="mx-auto" :numeroDocument="numeroDocument" />
      </div>

    </div>


  </div>


</template>

<script>
import { mapActions, mapGetters } from "vuex";
import EditarPostulantes from "@/components/ModSeleccion/Postulante/EditarPostulante.vue";
import Swal from "sweetalert2";
export default {
  name: "SolimanologTablasGestionSolicitudes",

  data() {
    return {
      numeroDocument: Number,
      postulanteCondic: true,
      postulanteCondicion: true,
      adams: false,

      mostrar: false,
      mostrarInput: true,
      dni_busqueda: "",
      prender: true,
      alerta: false,
      loader: true,
      cerrarTable1: true,
      cerrarTable2: false,
      tabla1: false,
      boton: true,
      alertita: false,
      retro: false,
      currentPage: 1,
      itemsPerPage: 7,
      loading: false,

      url: "https://apitopas.gruposolimano.com.pe/Documentos/CV/",
      bontoncitoDisabled: false,

      // JSON a mostrar
    };
  },

  components: {
    EditarPostulantes,
  },

  async mounted() {
    // const response = await this.axios.get(
    //   "Postulante/ListaPostulante"
    // );
    // // .then((datos) => {
    // // console.log(datos.data);
    // this.info = response.data;
    // this.loader = false;
    // this.tabla1 = true;
    // console.log(this.info)
    // });
    console.log(this.Info);
  },


  computed: {
    ...mapGetters("listadoPostulante", ["Info", "Loader", "Tabla1"]),

    filteredInfo() {
      if (!this.dni_busqueda) return this.Info;

      const texto = this.dni_busqueda.toLowerCase();

      return this.Info.filter(item =>
        item.posNroDocumento.toLowerCase().includes(texto) ||
        item.posApePaterno.toLowerCase().includes(texto) ||
        item.posApeMaterno.toLowerCase().includes(texto) ||
        item.posNombre.toLowerCase().includes(texto)
      );
    },

    paginatedInfo() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredInfo.slice(start, end);
    },

    totalPages() {
      return Math.ceil(this.filteredInfo.length / this.itemsPerPage);
    }
  },

  watch: {
    dni_busqueda() {
      this.loading = true;

      setTimeout(() => {
        this.loading = false;
      }, 800);
    }
  },




  created() {
    this.cambiarEstadoNavbar()
  },
  methods: {
    ...mapActions("listadoPostulante", [
      "getAttributesPostulante",
      "getAttributesPostulanteUsers",
    ]),

    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch('acciones/CambioNavbar', true);
    },

    editar(nroDoc) {
      // console.log(nroDoc);
      this.getAttributesPostulanteUsers(nroDoc);
      // console.log(nroDoc);
      this.numeroDocument = nroDoc;
      this.postulanteCondic = false;
      this.postulanteCondicion = false;
      this.mostrarInput = false;
      // this.$router.push("/EditarListado/" + nroDoc);
      console.log(this.numeroDocument);
    },

    posteos(idMaePostulante) {
      this.bontoncitoDisabled = true;
      let IdMaeSolicitud = this.$route.params.user;
      let IdUsuario = localStorage.getItem("userId");
      // console.log(IdMaeSolicitud)

      // console.log(idMaePostulante , IdMaeSolicitud)
      const fron = {
        IdMaeSolicitud,
        idMaePostulante,
        IdUsuario,
      };

      this.axios.post("SolicitudPostulante/Registrar", fron).then((r) => {
        const fron = {};

        console.log(fron);
        console.log(r);
        this.getAttributesPostulante().then(() => {
          this.bontoncitoDisabled = false;
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Se registró cambios",
            showConfirmButton: false,
            timer: 1500,
          });
        });
      });
    },

    filter(items) {
      // aqui nos aseguramos que el input contenga caracteres String y que valida
      // el v-model de this.nombre
      this.dni_busqueda.length < 3 ? (this.adams = false) : (this.adams = true);

      if (this.pag !== 1) {
        this.pag = 1;
      }

      return (
        items.posNroDocumento
          .toLocaleLowerCase()
          .indexOf(this.dni_busqueda.toLocaleLowerCase()) >= 0
      );
    },
    filter2(items) {
      this.dni_busqueda.length < 3 ? (this.adams = false) : (this.adams = true);

      return (
        items.posApePaterno
          .toLocaleLowerCase()
          .indexOf(this.dni_busqueda.toLocaleLowerCase()) >= 0
      );
    },
    regresare() {
      window.history.back();
    },

    listado() {
      this.tabla2 = false;

      this.postulanteCondicion = true;
      this.postulanteCondic = true;
      this.mostrarInput = true;
    },

    abrirSolicitud(id) {
      const routeData = this.$router.resolve({
        name: 'gestionSolicitud',
        params: { ide: id }
      });
      window.open(routeData.href, '_blank');
    },
    // nuevoPostulante() {
    //   this.mostrar = !this.mostrar;
    // },



    // console.log(this.NUM_RESULTS);

    mandar(id) {
      this.$router.push("/usuarioinfoPostulante/" + id);
    },
  },
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(22, 22, 22, 0.2) 0px 2px 8px 0px;
  width: 100%;
  /* margin-right: 0.5rem !important; */
  margin-top: 9px;
  margin-bottom: 9px;
  margin-left: 0.5%;
  margin-right: 0.5%;
  background: rgb(255, 255, 255);
  min-height: 100vh;
  overflow-x: auto;
  overflow-y: hidden;
}

.boton-estiloCuadrado {
  padding: 0.25rem 0.60rem;
  cursor: pointer;
}

.tabla-estiloCompreso {
  padding: 0.30rem 0.55rem;

}

.buscar-estiloCuadrado {
  border-radius: 0;
  font-size: 0.65rem;
  background-color: transparent;
  /* Fondo transparente */
}

.bg-solimano {
  background: #1565C0;
}


.bg-solimano-table {
  background: #0080c8;
}

.btn-solimano {
  background: #0080c8;
}

.tamaño {
  font-size: 0.65rem;

  font-weight: 800;

}

.reducirTamaño {
  font-size: 0.65rem;
}

.btn-link-estilo {
  background: none;
  border: none;
  color: #0080c8; /* Celeste inicial */
  font-weight: 700;
  transition: all 0.3s ease;
}

.btn-link-estilo:hover {
  cursor: pointer !important;
  text-decoration: underline !important;
  color: #002c5d !important; /* Celeste oscuro / Azul marino */
}
</style>
